<template>
  <span class="fa-stack">
    <i class="fas fa-circle fa-stack-2x"/>
    <i class="fas fa-stack-1x fa-inverse" :class="'fa-'+iconClass"/>
  </span>
</template>

<script>
  //@vuese
  //@group General/ui
  // Add or remove a new row icon
  export default {
    name: 'addRemoveRow',
    props: {
      //@vuese
      // Stacked icon for the component
      iconClass: {
        type: String,
        default: 'plus'
      }
    }
  }
</script>
